import { ReactNode, useRef, useState } from 'react'

import { useApplyBodyClass } from 'hooks/useScrollEffects'
import { useTransition } from 'hooks/useTransitions'

import Icon from 'components/elements/Icon'

import styles from './tooltip.module.scss'

type Props = {
  children?: ReactNode
  trigger?: React.ReactNode
  className?: string
  style?: React.CSSProperties
  onHover?: (e: React.MouseEvent) => void
  skipOnTouch?: boolean
}

const Tooltip = ({ children = null, trigger = null, style, className = '', onHover, skipOnTouch }: Props) => {
  const touched = useRef(false)
  const entered = useRef(false)

  const [hovered, setHovered] = useState(false)
  const [transitionRef] = useTransition(hovered, { duration: 200 })

  useApplyBodyClass(hovered, 'no-scrolling')

  return (
    <span
      className={styles.parent}
      onTouchStart={() => (touched.current = true)}
      onTouchEnd={() => setTimeout(() => (touched.current = false), 100)}
      onMouseEnter={e => {
        if (touched.current && skipOnTouch) return

        entered.current = true

        // Add small delay to prevent flashing when mousing over toolips
        setTimeout(() => {
          if (!entered.current) return

          setHovered(true)

          if (onHover) onHover(e)
        }, 50)
      }}
      onMouseLeave={() => {
        setHovered(false)
        entered.current = false
      }}>
      {trigger ? trigger : <Icon color="grey" name="info circle" />}

      {hovered && (
        <div ref={transitionRef} className={`${styles.tooltip} ${className}`} style={style}>
          {children}
        </div>
      )}
    </span>
  )
}

export default Tooltip
